import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { Router } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { BaseForm } from 'projects/admin/src/app/classes/base-form';
import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { TextblockModel } from 'projects/core/src/lib/models/textblock.model';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { SelectItem } from 'primeng/api';
import { TEXT_TYPES } from 'projects/core/src/lib/constants';

@Component({
  selector: 'app-textblock-new',
  templateUrl: './textblock-new.component.html',
  styleUrls: ['./textblock-new.component.scss']
})
export class TextblockNewComponent extends BaseForm implements OnInit {

  public optionsTypes: Array<SelectItem> = [];
  public form = this.fb.group({
    identifier: new UntypedFormControl('', [Validators.required]),
    type: new UntypedFormControl('', [Validators.required]),
    description: new UntypedFormControl(''),
  });

  constructor(
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private api: ApiService,
    private router: Router,
    private auth: AuthStateService,
    private transloco: TranslocoService
  ) {
    super();
  }

  ngOnInit() {
    if (this.auth.checkRightOrRedirect('admin.textblock.create')) {
      this.optionsTypes = FormHelper.getSelectList(TEXT_TYPES, null, this.transloco);
      this.ui.setFormFocus();
    }
  }

  onCancel(): void {
    this.router.navigate(['/contents/textblocks']);
  }

  onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid === true) {
      this.submitting = true;
      this.api.saveModel('textblocks', null, this.form.value).subscribe({
        next: (result: any) => {
          const textblock = new TextblockModel().deserialize(result.data);
          this.ui.toastSuccess(this.transloco.translate('common.messages.saved', { value: textblock.identifier }), this.transloco.translate('common.saved'));
          this.router.navigate(['/contents/textblocks', textblock.id]);
        },
        error: (error: any) => {
          this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
          FormHelper.setBackendErrors(this.form, error.fielderrors);
        }
      }).add(() => {
        this.submitting = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

}
